import { CurrentUserEntity, UserRole } from '../../domain/entities/CurrentUser'

export type CurrentUserAPIModel = {
  uuid: string
  email: string
  accountId: number
  role?: string
}

const toRole = (role?: string): UserRole => (role === 'admin' ? 'admin' : 'user')

export const mapApiToEntity = (api: CurrentUserAPIModel): CurrentUserEntity =>
  CurrentUserEntity.create({
    uuid: api.uuid,
    email: api.email,
    accountId: api.accountId,
    role: toRole(api.role),
  })
